<div>
  <input type="tel"
    class="form-control"
    [placeholder]="placeHolder"
    [formControl]="inputControl"
    [class.ng-invalid]="invalid || inputControl.invalid">
  </div>

  @if (inputControl.errors && inputControl.touched) {
    <div class="pt-2 text-danger">
      @if (inputControl.getError('invalidPhoneNumber')) {
        <p [innerHTML]="'form.invalidPhoneNumber' | translate: { phone: inputControl.value }"></p>
      }
      @if (inputControl.getError('invalidPhoneType')) {
        <p [innerHTML]="'form.invalidPhoneType' | translate"></p>
      }
    </div>
  }
